<template>


<section> 
      <b-container>
        <b-row align-v="center" class="row-grid">
          <b-col md="6" class="order-md-2">
            <b-img src="img/custom/lieber.png" fluid />
          </b-col>
          <b-col md="6" class="order-md-1">
            <div class="pr-md-5">
              <h1>Please select your country of origin</h1>

                    
              <base-input name="Country of Origin" rules="required">
                            <el-select v-model="currentSnapWizard.country_name" filterable placeholder="Country"
                                rules="required">
                                <el-option v-for="option in countries" :key="option.label" :label="option.label"
                                    :value="option.value">
                                </el-option>
                            </el-select>
                        </base-input>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>







</template>
<script>
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'
import { Tooltip } from 'element-ui'
import TagsInput from '@/components/Inputs/TagsInput'
import { Select, Option } from 'element-ui'

export default {
    name: 'snap04',
    components: {
        TagsInput,
        [Tooltip.name]: Tooltip,
        [Select.name]: Select,
        [Option.name]: Option,
    },
    data() {
        return {
            loading: false,
            countries: [],
        }
    },
    methods: {
        onCancel: function () { },
        onProceed: function () { },
        fetchCountries() {
            this.loading = true;
            this.$api.getCountries()
                .then((response) => {
                    const countries = response.data;
                    this.countries = countries.countries;
                    console.log(this.countries);
                })
                .catch((e) => {
                    console.log(e);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        allDataValidated: function () {
            console.log("current category -> ");
            console.log(this.currentSnapWizard.category);
            if (this.currentSnapWizard.country_name != "" && this.currentSnapWizard.country_name != undefined) {

                console.log("VALID ENABLING NEXT");
                this.$emit('allowProceed');
                this.$emit('showFooterNav');
                return true;
            }
            this.$emit('denyProceed');
            this.$emit('hideFooterNav');
            return false;
        },
    },
    computed: {
        ...mapGetters({
            currentSettings: 'currentSettings',
            currentSnapWizard: 'currentSnapWizard',
            currentSnapWizardStep: 'currentSnapWizardStep',
        }),
    },
    watch: {
        currentSnapWizard: {
            handler: function (newItem) {
                this.allDataValidated();
            },
            deep: true
        },
    },
    mounted() {
        this.$emit('denyProceed');
        this.$emit('hideFooterNav');
        this.allDataValidated();
        this.fetchCountries();
    }
};
</script>